import React, { Component } from 'react';
import { Col } from "antd";
import "./index.scss";


class index extends Component {
    render() {
        return (
            <div className="theChart">
                Rooms Dept Profit %  客房部门利润率
                <div id="room" style={{ height: 400, width: '100%' }}></div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/room.js